module.exports = __webpack_public_path__ + "img/CenterPoint.fe68a17f.jpg";